// extracted by mini-css-extract-plugin
export default {"content":"privacy_content__DZ7IL","blacktext":"privacy_blacktext__V8QJM","bannerContainer":"privacy_bannerContainer__HuLj1","bannerButton":"privacy_bannerButton__FI12t"};